import { render } from "./ContractDocs.vue?vue&type=template&id=3354c24e"
import script from "./ContractDocs.vue?vue&type=script&lang=js"
export * from "./ContractDocs.vue?vue&type=script&lang=js"

import "./ContractDocs.vue?vue&type=style&index=0&id=3354c24e&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__